export type TimeRange = [number, number]

export type TimeRangeObjT = { after: number, before: number }

export type UnknownStringKeyT = { [key: string]: unknown }
export type AnyStringKeyT = { [key: string]: any }
